/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AssessmentQueryFramework extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AssessmentQueryFramework");
    }

    getFixupPrototypeFunction() { return AssessmentQueryFramework.fixupPrototype; }

    static newInstance(model: Partial<AssessmentQueryFramework>): AssessmentQueryFramework {
        let obj = Object.assign(new AssessmentQueryFramework(), model);
        AssessmentQueryFramework.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AssessmentQueryFramework>): AssessmentQueryFramework {
        if (!model) return null;
        return AssessmentQueryFramework.newInstance(<AssessmentQueryFramework> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AssessmentQueryFramework) {
        if (!obj) return;

        models.AssessmentQueryFramework.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AssessmentQueryFramework): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AssessmentQueryFramework.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * ID of framework
     */
    framework_ids: Array<string>;

}
